import * as React from 'react';
import {Avatar, TAvatarType} from '../../Components/Avatar/Avatar';
import {Icon} from '@iconify/react';
import classNames from 'classnames';


export class User extends React.Component<{
    onMenuClick?: (e: any) => void;
    name: string;
    status: string;
    online?: boolean;
    style?: React.CSSProperties;
    selected?: boolean;
    avatarType?: TAvatarType;
    avatar?: string;
    unread?: number;
    leftBadge?: string;
    expanded: boolean;
    names?: string[];
    onNameChange?: (value: string) => void;
}> {
    public render() {
        const [name, id] = this.props.name.split('#');
        const {onNameChange} = this.props;
        return (
            <div
                className={classNames('mvc-account-component', {
                    selected: this.props.selected,
                })}
                style={this.props.style}
            >
                {!!this.props.unread && (
                    <span
                        className={
                            'mvc-account-component-notification-badge'
                        }
                        children={this.props.unread}
                    />
                )}
                <Avatar
                    uri={this.props.avatar}
                    selected={this.props.selected}
                    type={this.props.avatarType}
                    online={this.props.online}
                />
                <div className={'mvc-account-component-text'}>
                    <div
                        className={'mvc-account-component-text-name'}
                    >
                        {this.props.names && name !== 'Guest' ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'context-menu',
                                }}
                            >
                                {name}
                                <select
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={
                                        onNameChange
                                            ? (e) => onNameChange(e.target.value)
                                            : undefined
                                    }
                                    value={name}
                                    inputMode={'text'}
                                    style={{
                                        all: 'unset',
                                        paddingRight: 124,
                                        zIndex: 1,
                                        width: 0,
                                        backgroundColor: 'transparent',
                                        color: '#fff',
                                        textShadow: `0 1px 0 rgba(0, 0, 0, 0.4)`,
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        outline: 'none',
                                        opacity: 0,
                                    }}
                                >
                                    {this.props.names.map((name) => (
                                        <option
                                            style={{
                                                backgroundColor: `rgba(0, 0, 0, .8)`,
                                                textShadow: `0 1px 0 rgba(0, 0, 0, 0.4)`,
                                            }}
                                            key={name}
                                            value={name}
                                        >
                                            {name}
                                        </option>
                                    ))}
                                </select>
                                <Icon
                                    icon={'clarity:edit-solid'}
                                    height={14}
                                    style={{
                                        boxSizing: 'border-box',
                                        marginLeft: 4,
                                    }}
                                />
                            </div>
                        ) : (
                            name
                        )}
                        {id && (
                            <span
                                style={{
                                    fontSize: 12,
                                    fontWeight: 200,
                                    position: 'relative',
                                }}
                            >
                #{id}
                                {this.props.leftBadge && (
                                    <Icon
                                        className={
                                            'mvc-account-component-notification-badge request'
                                        }
                                        style={{
                                            boxSizing: 'unset',
                                        }}
                                        icon={this.props.leftBadge}
                                    />
                                )}
              </span>
                        )}
                    </div>
                    <div
                        className={'mvc-account-component-text-status'}
                    >
                        {this.props.status}
                    </div>
                </div>
                {this.props.onMenuClick && (
                    <Icon
                        className={classNames(
                            'mvc-account-component-icon',
                            {expanded: this.props.expanded},
                        )}
                        icon={'majesticons:dots-horizontal'}
                        height={20}
                        onClick={this.props.onMenuClick}
                    />
                )}
            </div>
        );
    }
}
